export default __webpack_public_path__ + "static/media/typicalweek (1).da006fd4.png";